import { NgModule } from '@angular/core';
import {EveCallQueuePageModule} from "./call-queue/eve-call-queue-page.module";
import { EveSlipTrunkPageModule } from './sip-trunk/eve-sip-trunk-page.module';
import { CallRecordingPagesModule } from './call-recording/call-recording-pages.module';

@NgModule({
  exports:[
  ],
  declarations: [],
  imports: [
    EveCallQueuePageModule,
    EveSlipTrunkPageModule,
    CallRecordingPagesModule
  ]

})
export class EvePagesModule {}
